import { ReactNode } from "react";

// import styles from "./EntryLayout.module.scss";
import { Flex, Layout } from "antd";
import Logo from "components/Logo";

function EntryLayout({ children }: { children: ReactNode }) {
  return (
    <Layout>
      <Layout.Content
        style={{ minHeight: "100vh", background: "url(https://firstchoicedebtsolutions.org/fcds-bg.png)" }}
      >
        <Flex justify="center" align="center" vertical gap={24} style={{ height: "80vh" }}>
          <div
            className="border bg-violet-50 border-brand-500/20 shadow-lg shadow-brand-500/20 rounded-2xl"
            style={{ width: "80%", maxWidth: "500px" }}
          >
            <Flex justify="center" align="center" className="my-8">
              <Logo />
            </Flex>
            {/* <Divider /> */}
            <div className="rounded-2xl bg-white p-6">{children}</div>
          </div>
        </Flex>
      </Layout.Content>
    </Layout>
  );
}

export default EntryLayout;
